const PageData = {
  appFrame: undefined,
}

export default PageData
